// textHelpers.ts 
export const getInitials = (fullName?: string): string => {
  if (!fullName || fullName.trim() === "" || fullName === "--") {
    return "--";
  }

  const firstWord = fullName.trim().split(/\s+/)[0];

  return firstWord.slice(0, 3).toUpperCase();
};

export const isValidDisplayValue = (value?: string | null): boolean =>
  !!value && value.trim() !== "" && value !== "--";

export const getDisplayValue = (
  value?: string | null,
  fallback = "--",
): string => (isValidDisplayValue(value) ? value!.trim() : fallback);
